import * as React from "react";
function SvgCircleBang(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={15}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M17.23 9.33l-.53 8.58a.7.7 0 01-.7.7.73.73 0 01-.7-.7l-.53-8.58a1.25 1.25 0 112.49-.17.25.25 0 00-.03.17zM16 21.14A1.43 1.43 0 0116 24a1.42 1.42 0 01-1.43-1.43A1.44 1.44 0 0116 21.14z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleBang);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
